(() => {
  'use strict';
  const configElement = document.getElementById('ventana-sample-rules');
  if (!configElement || window.ventanaSampleRulesLoaded) return;
  window.ventanaSampleRulesLoaded = true;
  const config = JSON.parse(configElement.textContent);
  const sampleIds = new Set(config.variantIds.map(String));
  const originalFetch = window.fetch.bind(window);
  const sample = item => sampleIds.has(String(item.variant_id || item.id));
  const total = cart => cart.items.reduce((sum, item) => sum + (sample(item) ? item.quantity : 0), 0);
  const quantity = value => Math.max(0, Number(value) || 0);
  let pending = Promise.resolve();
  let alertTimer;
  function announce(message) {
    let alert = document.getElementById('ventana-sample-alert');
    if (!alert) {
      alert = document.createElement('div');
      alert.id = 'ventana-sample-alert';
      alert.className = 'ventana-sample-alert';
      alert.setAttribute('role', 'alert');
      alert.setAttribute('tabindex', '-1');
      document.body.appendChild(alert);
    }
    alert.textContent = message;
    alert.hidden = false;
    clearTimeout(alertTimer);
    alertTimer = setTimeout(() => { alert.hidden = true; }, 9000);
  }
  async function getCart() {
    const response = await originalFetch(config.cartUrl, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error(config.retryMessage);
    return response.json();
  }
  function decode(body) {
    if (!body) return {};
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch { body = new URLSearchParams(body); }
    }
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const result = {};
      for (const [key, value] of body.entries()) {
        const indexed = key.match(/^updates\[([^\]]*)\]$/);
        if (indexed) {
          if (indexed[1]) {
            result.updates ||= {};
            result.updates[indexed[1]] = value;
          } else {
            result.updates ||= [];
            result.updates.push(value);
          }
        } else result[key] = value;
      }
      return result;
    }
    return body;
  }
  function projected(cart, action, data) {
    let count = total(cart);
    if (action === 'add') {
      for (const item of data.items || [data]) {
        if (sampleIds.has(String(item.id))) count += quantity(item.quantity ?? 1);
      }
    } else if (action === 'change') {
      const item = data.line ? cart.items[Number(data.line) - 1] : cart.items.find(item => String(item.key) === String(data.id) || String(item.id) === String(data.id));
      if (item && sample(item)) count += quantity(data.quantity) - item.quantity;
    } else if (action === 'update' && data.updates) {
      const updates = data.updates;
      const found = new Set();
      cart.items.forEach((item, index) => {
        if (!sample(item)) return;
        const next = Array.isArray(updates) ? updates[index] : (updates[item.key] ?? updates[item.id]);
        if (next !== undefined) count += quantity(next) - item.quantity;
        found.add(String(item.id));
        found.add(String(item.key));
      });
      if (!Array.isArray(updates)) {
        for (const [id, value] of Object.entries(updates)) {
          if (sampleIds.has(String(id)) && !found.has(String(id))) count += quantity(value);
        }
      }
    }
    return count;
  }
  window.fetch = function(input, init) {
    const url = new URL(input instanceof Request ? input.url : String(input), location.href);
    const match = url.origin === location.origin && url.pathname.match(/\/cart\/(add|change|update)(?:\.js)?\/?$/);
    const method = String(init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (!match || method !== 'POST') return originalFetch(input, init);
    const request = async () => {
      const body = init?.body ?? (input instanceof Request ? await input.clone().text() : null);
      const data = decode(body);
      const cart = await getCart();
      const before = total(cart);
      const after = projected(cart, match[1], data);
      if (after > config.limit && after > before) {
        announce(config.limitMessage);
        if (match[1] === 'add') return new Response(JSON.stringify({status: 422, message: config.limitMessage, description: config.limitMessage}), {status: 422, headers: {'Content-Type': 'application/json'}});
        return new Response(JSON.stringify(cart), {headers: {'Content-Type': 'application/json'}});
      }
      return originalFetch(input, init);
    };
    const result = pending.then(request);
    pending = result.catch(() => {});
    return result;
  };
  const approved = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    const url = new URL(form.action, location.href);
    const adding = /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    const cartForm = /\/cart\/?$/.test(url.pathname);
    if (!adding && !cartForm) return;
    if (approved.has(form)) { approved.delete(form); return; }
    const data = decode(new FormData(form));
    if (adding && !sampleIds.has(String(data.id))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await pending;
      const cart = await getCart();
      const count = projected(cart, adding ? 'add' : 'update', data);
      const checkingOut = cartForm && (event.submitter?.name === 'checkout' || !event.submitter);
      if (count > config.limit && (checkingOut || count >= total(cart))) {
        announce(config.limitMessage);
        return;
      }
      approved.add(form);
      form.requestSubmit(event.submitter || undefined);
    } catch { announce(config.retryMessage); }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    try {
      await pending;
      const cart = await getCart();
      if (total(cart) > config.limit) { announce(config.limitMessage); return; }
      location.assign(link.href);
    } catch { announce(config.retryMessage); }
  }, true);
})();
